<template>
  <v-app white class="grey-text white">

    <!-- Shopping cart -->
    <ShoppingCart :drawerRight="drawerRight" :drawer="drawer"/>

    <!-- Navigation menu -->
    <v-app-bar app
               fixed
               clipped-right
               elevate-on-scroll
               height="100px"
               class="text-capitalize
                      overflow-hidden
                      grey--text white">

      <!-- mobile and small screen navigation -->
      <v-fab-transition v-if="drawer || drawerRight">
        <v-btn icon
               class="mr-3 hidden-lg-and-up"
               v-if="drawer"
               v-show="drawer"
               @click="drawer = !drawer">
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-btn icon
               class="mr-3 hidden-lg-and-up"
               v-else
               v-show="drawerRight"
               @click="drawerRight = !drawerRight">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-fab-transition>
        <v-app-bar-nav-icon class="mr-3 hidden-lg-and-up"
                            v-show="!drawer"
                            @click="drawer = !drawer">
        </v-app-bar-nav-icon>
      </v-fab-transition>
      <!-- large screen and up navigation -->
      <!-- Brand icon  -->
      <v-toolbar-icon>
        <v-img  src="./assets/img/logo_fb.jpg"
                left 
                max-width="60"
                max-height="60">
        </v-img>
      </v-toolbar-icon>
      
      <!-- Brand Title -->
      <div class="ma-4 headline">
        <p 
          class="font-weight-light mb-0">
            lisboa 
        </p>
        <p 
          class="font-weight-bold my-0">
          saudade 
        </p>
      </div>

      <!-- list of the pages -->
      <div class="flex-grow-1"></div>
      <v-tabs grow
              background-color="transparent"
              color="grey darken-3"
              class="hidden-md-and-down
                      mx-lg-auto">
        <v-tab v-for="(link, i) in links" 
                :key="i"
                :to="link.route">
            {{ link.name }}
        </v-tab>
      </v-tabs>
      <v-fab-transition>
        <!-- open Shopping cart icon -->
        <v-btn icon
              v-show="!drawerRight"
              @click="drawerRight = !drawerRight">
          <v-icon>fa-shopping-bag</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-fab-transition>
      <!-- close Shopping cart icon -->
        <v-btn icon
               v-show="drawerRight"
               @click="drawerRight = !drawerRight">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-fab-transition v-if="drawerRight">
        <v-btn icon
               class="mr-3 hidden-lg-and-up"
               v-show="drawer"
               @click="drawer = !drawer">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-app-bar>

    <!-- mobile navigation -->
    <MobileMenu :drawer="drawer" :links="links"/>
    <!-- <v-navigation-drawer v-model="left"
                         fixed
                         temporary>
    </v-navigation-drawer> -->

    <!-- Main content -->
    <v-content fluid :aspect-ratio="16/9"
               class="white">
        <router-view />
    </v-content>

    <!-- Footer -->
    <Footer class="ma-aut"/>
    <!-- Shopping cart -->
    <!-- <v-navigation-drawer v-model="right"
                         fixed
                         right
                         temporary>
    </v-navigation-drawer> -->
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';
import MobileMenu from '@/components/Layout/MobileMenu';
import ShoppingCart from '@/components/Layout/ShoppingMenu';
import Footer     from '@/components/Layout/Footer';
import MainFont   from '@/assets/css/main.css';

export default {
  name: 'App',
  source: String,
  components: {
    HelloWorld,
    MobileMenu,
    ShoppingCart,
    Footer,
    MainFont
  },
  data: () => ({
      drawer: false,
      drawerRight: false,
      links: [
        {
          name: 'Home',
          route: '/'
        },
        {
          name: 'Products',
          route: '/products'
        },
        {
          name: 'Refund and Return',
          route: '/refund'
        },
        {
          name: 'Contact',
          route: '/about'
        }
      ]
  }),
};
</script>
